var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mpl-parcel-locker',{attrs:{"pickup-point":_vm.pickupPoint,"skip-groups":_vm.skipGroups},on:{"input":_vm.setPickupPoint}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }